import React from "react";
import AppRoutes from "./Components/AppRoutes/AppRoutes";
import "./App.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";

export default function App() {
  
  return (
    <Provider store={store}>
      <AppRoutes />
    </Provider>
  );
}
